import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Link, useHistory } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import httpServices from "../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import sizesBanner from "./../sizes-banner";
import validationsAddPosition from "../../../../validations/forms/position/add";

export default function AddPositions() {
  const params = useParams();
  const sitePublisherID = parseInt(params.publisherID);
  const [message, setMessage] = useState();
  const [count, setCount] = useState(0);
  const [basePrice, setBasePrice] = useState(10000);
  const [price, setPrice] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [activeAlternative, setActiveAlternative] = useState(true);
  const history = useHistory();
  const [sitePublisher, setSitePublisher] = useState();
  const [imageSitePublisher, setImageSitePublisher] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    scrollForSeeMessage(".card-body");
    getSitePublisher();
  }, []);

  useEffect(() => {
    if (!sitePublisher) {
      return;
    }
    getImageSitePublisher();
  }, [sitePublisher]);

  useEffect(() => {
    changePrice();
  }, [basePrice]);

  useEffect(() => {
    changePrice();
  }, [count]);

  const changePrice = () => {
    if (!(count > 0)) {
      setPrice(0);
      return;
    }
    setPrice(Math.floor(basePrice / count));
  };

  const getImageSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let imageSitePublisher = await sendRequestGetImageSitePublisher(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!imageSitePublisher) {
      return;
    }

    setImageSitePublisher(imageSitePublisher.url);
  };

  const sendRequestGetImageSitePublisher = async (publisherID) => {
    const headersRequest = getHeaderRequest();
    let imageSitePublisher;
    try {
      imageSitePublisher = await httpServices.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/publisher/site/${publisherID}/get-image`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return imageSitePublisher.data.data;
  };

  const getSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let sitePublisher = await sendRequestGetSitePublisher(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!sitePublisher) {
      return;
    }

    setSitePublisher(sitePublisher);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetSitePublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderRequest();
    let sitePublisher;
    try {
      sitePublisher = await httpServices.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/publisher/site/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return sitePublisher.data.data;
  };

  const inputPriceChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setBasePrice(parseInt(number));
  };

  const inputPriceBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const generateButtonsSize = () => {
    return sizesBanner.map((sizeBanner) => {
      return (
        <div className="col-6 col-md-2 py-2">
          <div
            onClick={(e) => {
              e.preventDefault();
              setWidth(sizeBanner.width);
              setHeight(sizeBanner.height);
            }}
            className="btn btn-primary letter-spacing-finance-number p-2"
          >
            {helpersNumbers.toPersianNum(sizeBanner.height)}
            {"    "}-{"    "}
            {helpersNumbers.toPersianNum(sizeBanner.width)}
          </div>
        </div>
      );
    });
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".card-body");
    element.scrollIntoView();
  };

  const sendForm = async () => {
    const dataForm = getDataForm();
    const resultValidationsAddPosition = validationsAddPosition(dataForm);
    if (resultValidationsAddPosition != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidationsAddPosition,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }
    dataForm.web_site_publisher_id = sitePublisherID + "";
    await addPosition(dataForm);
  };

  const addPosition = async (dataForm) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddPosition = await sendRequestAddPosition(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddPosition) {
      return;
    }
    history.push(
      `/positions/independent/all/web-site-publisher/${sitePublisherID}`
    );
  };

  const sendRequestAddPosition = async (data) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpServices.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/position/independent",
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getDataForm = () => {
    return {
      base_price: basePrice + "",
      price: price + "",
      count: document.querySelector("#count").value,
      height: document.querySelector("#height").value,
      width: document.querySelector("#width").value,
      active: +document.querySelector("#active").checked + "",
      allow_alternative: document.querySelector("#active-advertise-alternative")
        .checked,
    };
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar
          title={` جایگاه های مستقل سایت ${
            sitePublisher && sitePublisher.url.replace("https://", "")
          } `}
        />
        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  className="btn btn-primary"
                  to={`/positions/independent/all/web-site-publisher/${sitePublisherID}`}
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    sendForm();
                  }}
                >
                  <div className="form-group">
                    <label>تعداد بنر در جایگاه</label>
                    <input
                      tabIndex="1"
                      dir="ltr"
                      type="number"
                      id="count"
                      onChange={(e) => {
                        e.preventDefault();
                        setCount(parseInt(e.target.value));
                      }}
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>مبلغ پایه </label>
                    <input
                      tabIndex="2"
                      type="text"
                      id="price"
                      className="form-control number-finance"
                      value={helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(basePrice)
                      )}
                      onChange={inputPriceChangeHandler}
                      onBeforeInput={inputPriceBeforeInputHandler}
                      dir="ltr"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>مبلغ نمایش یک تبلیغ در یک شبانه روز :‌ </label>
                    <span
                      className="letter-spacing-finance-number"
                      style={{ fontSize: "22px" }}
                    >
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(price)
                      )}
                    </span>
                  </div>

                  <div className="form-group">
                    <label className="pl-2">فعال بودن تبلیغ جایگزین بنری</label>
                    <span>
                      <label className="adl-switch">
                        <input
                          type="checkbox"
                          id="active-advertise-alternative"
                          checked={activeAlternative}
                          onChange={() => {
                            setActiveAlternative(!activeAlternative);
                          }}
                        />
                        <span className="adl-slider round"></span>
                      </label>
                    </span>
                  </div>

                  {activeAlternative && (
                    <div className="form-group">
                      <label>
                        Hicoin نمایش یک تبلیغ بنری جایگزین در یک شبانه روز :{" "}
                      </label>
                      <span
                        className="letter-spacing-finance-number"
                        style={{ fontSize: "22px" }}
                      >
                        {price <=
                        parseInt(
                          process.env.REACT_APP_MAX_SCORE_ALTERNATIVE_POSITION
                        )
                          ? helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(price)
                            )
                          : helpersNumbers.toPersianNum(
                              helpersNumbers.toFormatFinanceNumber(
                                process.env
                                  .REACT_APP_MAX_SCORE_ALTERNATIVE_POSITION
                              )
                            )}
                      </span>
                    </div>
                  )}

                  <div className="form-group">
                    <div className="pb-3">
                      <label>
                        اندازه بنرهای تبلیغاتی ( ارتفاع - عرض) پیکسل
                      </label>
                      <div className="container-fluid">
                        <div className="row">{generateButtonsSize()}</div>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="pl-0 pl-md-2">
                        <label>ارتفاع</label>
                        <input
                          dir="ltr"
                          type="number"
                          id="height"
                          value={height || ""}
                          className="form-control"
                          required
                        />
                      </div>
                      <div>
                        <label>عرض</label>
                        <input
                          dir="ltr"
                          type="number"
                          id="width"
                          value={width || ""}
                          className="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <span className="pl-2">
                      <label>فعال</label>
                    </span>
                    <span>
                      <label className="adl-switch">
                        <input type="checkbox" id="active" />
                        <span className="adl-slider round"></span>
                      </label>
                    </span>
                  </div>

                  <div className="form-group">
                    <button className="btn btn-success">اضافه کردن</button>
                  </div>

                  <div className="form-group">
                    <div className="border border-success">
                      <a href={imageSitePublisher} target="_blank">
                        <img className="img-fluid" src={imageSitePublisher} />
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
